import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent implements OnInit {

  constructor(private title: Title, private translateService: TranslateService) { }

  ngOnInit(): void {
    this.translateService.get('title_register').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

}
